import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("message-box", () => {
    it("should close when the close button is clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-message-box type="info" intro="Info">
            </ux-message-box>`);
        let el = await page.find("ux-message-box");
        expect(el).toHaveClass("hydrated");
        const closeEl = await page.find(".ux-message-box__close");
        await closeEl.click();
        el = await page.find("ux-message-box");
        expect(el).toBeFalsy();
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-message-box></ux-message-box>`);
        const el = await page.find("ux-message-box.hydrated");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-message-box></ux-message-box>`);
    });
});
